/**
 * @param {number} value
 * @returns {string}
 */
export const styleSizeValue = (value) => (Number.isNaN(+value) ? value : `${value}px`)
